import { createApp } from 'vue'
import mitt from 'mitt'
import { library } from '@fortawesome/fontawesome-svg-core'
import { createToastUtilObject } from '../helpers/toast_helpers'

import {
  faCheck as farCheck,
  faCircleExclamation as farCircleExclamation,
  faArchive as farArchive,
  faTrashCan as farTrashCan,
} from '@fortawesome/pro-regular-svg-icons'

library.add(farCheck, farCircleExclamation, farArchive, farTrashCan)

import BaseToast from '../../src/components/BaseToast.vue'

function setToastContainerStyle(div) {
  div.style.display = 'flex'
  div.style.flexDirection = 'column'
  div.style.gap = 'var(--space-2)'

  div.style.position = 'fixed'
  div.style.bottom = '16px'
  div.style.left = '50%'
  div.style.transform = 'translateX(-50%)'
  div.style.zIndex = '100001' // above our modal
  div.style.alignItems = 'center'
  div.style.width = '100vw'
  div.style.padding = '0 16px'
}

export const toastPlugin = {
  install(app) {
    const emitter = mitt()
    const emitToast = (toast) => {
      emitter.emit('toast', toast)
    }

    const Toast = createToastUtilObject(emitToast)

    app.config.globalProperties.$toast = Toast

    const toastApp = createApp(BaseToast)
    toastApp.config.globalProperties.$emitter = emitter

    const vueToastContainer = getToastContainer()
    setToastContainerStyle(vueToastContainer)

    const toastDivId = 'vue_toast_app' + new Date().getTime().toString()
    const toastDiv = document.createElement('div')
    toastDiv.id = toastDivId
    vueToastContainer.appendChild(toastDiv)

    toastApp.mount(`#${toastDivId}`)
  },
}

function getToastContainer() {
  let vueToastContainer = document.getElementById('vue_toast_apps_container')
  if (!vueToastContainer)
    vueToastContainer = createToastContainer()

  return vueToastContainer
}

function createToastContainer() {
  const vueToastContainer = document.createElement('div')
  vueToastContainer.id = 'vue_toast_apps_container'
  document.body.appendChild(vueToastContainer)
  return vueToastContainer
}
